<script>
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";

export default {
    name: "BudgetProposalModal",
    components: {
        Multiselect,
        DatePicker,
    },
    data() {
        return {
            submitted: false,
            form: {
                id: 0,
                description: null,
                campusIds: null,
                isActive: true,
                startDateTime: null,
                endDateTime: null,
            },
            campuses: this.$store.state.decrypt.campusAccessList(),
        }
    },
    validations: {
        form: {
            description: { required },
            campusIds: { required },
            startDateTime: { required },
            endDateTime: { required },
        },
    },
    methods: {
        updateData(proposal) {
            let campusIds = [];
            proposal.campuses.map(c => {
                let fCampus = this.campuses.find(x => x.Id == c.id);
                if (fCampus) {
                    campusIds.push(fCampus);
                }
            });
            this.form = {
                id: proposal.id,
                description: proposal.description,
                campusIds: campusIds,
                isActive: proposal.isActive,
                startDateTime: new Date(proposal.startDateTime),
                endDateTime: new Date(proposal.endDateTime),
                lockToCycle: proposal.lockToCycle,
            }
        },
        resetForm() {
            this.form = {
                id: 0,
                description: null,
                campusIds: null,
                isActive: true,
                startDateTime: null,
                endDateTime: null,
                lockToCycle: false,
            }
        },
        onCreate() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                return;
            }
            let data = JSON.parse(JSON.stringify(this.form));
            data.campusIds = this.form.campusIds.map(c => c.Id);
            data.campuses = this.form.campusIds.map(c => ({ id: c.Id, campusName: c.CampusName }));
            data.startDateTime = this.getDate(this.form.startDateTime);
            data.endDateTime = this.getDate(this.form.endDateTime);
            this.$emit('submit', data);
        }
    }
};
</script>
<template>
    <b-modal id="budget-proposal-modal" title="Budget Proposal Template" size="md" title-class="font-18" hide-footer
        no-close-on-backdrop>
        <form @submit.prevent="onCreate" class="needs-validation">
            <div class="mb-3">
                <label class="d-block mb-1">Description</label>
                <textarea v-model="form.description" :class="{ 'is-invalid': submitted && $v.form.description.$error }"
                    class="form-control" placeholder="Enter description..." rows="3"></textarea>
                <div v-if="submitted && $v.form.description.$error" class="invalid-feedback">
                    Description is required.
                </div>
            </div>
            <div class="mb-3">
                <label for="title">Start Date & Time</label>
                <date-picker v-model="form.startDateTime" :first-day-of-week="1" lang="en"
                    placeholder="Enter Start Date & Time..." type="datetime" format="MMM D YYYY hh:mm A"
                    :time-picker-options="{ start: '00:00', step: '00:30', end: '23:30', format: 'hh:mm A' }" :class="{
                        'is-invalid':
                            submitted && $v.form.startDateTime.$error,
                    }"></date-picker>
                <div v-if="submitted && $v.form.startDateTime.$error" class="invalid-feedback">
                    <span v-if="!$v.form.startDateTime.required">This value is required.</span>
                </div>
            </div>
            <div class="mb-3">
                <label for="title">End Date & Time</label>
                <date-picker v-model="form.endDateTime" :first-day-of-week="1" lang="en"
                    placeholder="Enter End Date & Time..." type="datetime" format="MMM D YYYY hh:mm A"
                    :time-picker-options="{ start: '00:00', step: '00:30', end: '23:30', format: 'hh:mm A' }" :class="{
                        'is-invalid':
                            submitted && $v.form.endDateTime.$error,
                    }"></date-picker>
                <div v-if="submitted && $v.form.endDateTime.$error" class="invalid-feedback">
                    <span v-if="!$v.form.endDateTime.required">This value is required.</span>
                </div>
            </div>
            <div class="mb-3">
                <label class="d-block mb-0 line-height-1">Campuses</label>
                <multiselect v-model="form.campusIds" :multiple="true" :options="campuses"
                    placeholder="Enter Campuses..." track-by="Id" label="CampusName" :close-on-select="false" :class="{
                        'is-invalid': submitted && $v.form.campusIds.$error,
                    }" autocomplete="off">
                </multiselect>
                <div v-if="submitted && $v.form.campusIds.$error" class="invalid-feedback d-block">
                    At least one campus must be selected.
                </div>
            </div>
            <div class="form-check form-checkbox-outline form-check-success mb-2">
                <input type="checkbox" :id="`active`" v-model="form.isActive" class="form-check-input" />
                <label :for="`active`" class="form-check-label">
                    Active
                </label>
            </div>
            <div class="form-check form-checkbox-outline form-check-success mb-3">
                <input type="checkbox" :id="`lockToCycle`" v-model="form.lockToCycle" class="form-check-input" />
                <label :for="`lockToCycle`" class="form-check-label">
                    Lock all targets to this proposal cycle
                </label>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary">
                    Save Proposal Template
                </button>
                <button type="button" class="btn btn-link" @click="$bvModal.hide('budget-proposal-modal')">
                    Close
                </button>
            </div>
        </form>
    </b-modal>
</template>